module.exports = __webpack_public_path__ + "img/man_image.74136d59.png";